module.exports = __webpack_public_path__ + "static/86-6a953beb1a4002583c719220e9a912b4.png";